import { z } from 'zod'

export const GetDirectionSchema = z.object({
  total: z.number(),
})

export const GetRouteSchema = z.object({
  coords: z.string(),
  distance: z.number(),
  steps: z
    .object({
      polyline: z.object({
        points: z.string(),
      }),
    })
    .array(),
})
